var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotepad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "15 105.001 105 105.001 105 15.001 15 15.001"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 30,
    y1: 85,
    y2: 85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 30,
    y1: 70,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 30,
    y1: 55,
    y2: 55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45,
    x2: 45,
    y1: 10.001,
    y2: 20.001
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    x2: 60,
    y1: 10.001,
    y2: 20.001
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 30,
    y1: 10.001,
    y2: 20.001
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    x2: 75,
    y1: 10.001,
    y2: 20.001
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 90,
    y1: 10.001,
    y2: 20.001
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepad);
export default __webpack_public_path__ + "static/media/notepad.2d6efe77ba7ed6e0e1f7b2d8afacc057.svg";
export { ForwardRef as ReactComponent };